import React, { useEffect, useState } from "react";
import styles from './ImgCarousel.module.css';

export default function ImgCarousel({imgArray}){

    const [selectedIndex,setSelectedIndex] = useState(0);
    const [formattedArray,setFormattedArray] = useState([]);

    useEffect(() => {
        setSelectedIndex(0);
        const newArray = imgArray.map((img) => img.replace('/s/','/shared/static/'))
        setFormattedArray(newArray);
    },[imgArray]);

    const imgSelector = (img,index) => {
        return (
            <div className={`${styles.selectImgCon} ${index === selectedIndex? styles.selected : ''}`}>
                <img onClick={() => setSelectedIndex(index)} src={img}/>
            </div>
        )
    }

    return (
        <div className={`${styles.container} ${formattedArray.length < 2? styles.single : ''}`}>
            {formattedArray.length > 1? <div className={styles.selectorSection}>
                {formattedArray.map((img,index) => imgSelector(img,index))}
            </div> : ''}
            <div className={styles.imgSection}>{imgArray.length > 0? formattedArray.map((img,index) => <img style={{display: `${index === selectedIndex? 'block' : 'none'}`}} src={img}/>) : ''}</div>
        </div>
    )
}